@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .viewAllButton {
    @include typography-v2-body-sm;
    fill: var(--text-default);
    margin: 20px;
  }

  .viewAllButtonWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .borderPath {
    stroke: var(--border-soft);
  }

  .backgroundPath {
    fill: var(--background-default);
  }
}
